import { digestCandidate, modelToOps, type PresetModel } from "@defibrillator/preset-core";
import type { LocalPresetRecord } from "../../shared/types.js";
import type { VitalTargetVersion } from "@defibrillator/vital-adapter";

export type PresetEditorSnapshot = {
  presetId: string;
  baseVersionId: string;
  baseContentHash?: string;
  savedModel: PresetModel;
  prompt: string;
  slug?: string;
  vitalVersion?: VitalTargetVersion;
};

export function modelDigest(model: PresetModel): string {
  return digestCandidate(model);
}

export function isDraftDirty(draft: PresetModel, saved: PresetModel): boolean {
  return modelDigest(draft) !== modelDigest(saved);
}

export function openEditorFromRecord(record: LocalPresetRecord): PresetEditorSnapshot | null {
  if (!record.versionId) return null;
  return {
    presetId: record.id,
    baseVersionId: record.versionId,
    baseContentHash: record.contentHash,
    savedModel: structuredClone(record.model),
    prompt: record.prompt,
    slug: record.slug,
    vitalVersion: record.vitalVersion,
  };
}

export function draftOps(model: PresetModel) {
  return modelToOps(model);
}
